import axios from "axios";

function them(phieuKhaoSat){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/phieukhaosat/them",phieuKhaoSat);
};
function getAll(){
  return axios.get(process.env.REACT_APP_URL_SERVER+"/cus/phieukhaosat/getall");
};
function getByID(id){
  return axios.get(process.env.REACT_APP_URL_SERVER+"/cus/phieukhaosat/getbyid/"+id);
};
function capNhat(phieuKhaoSat){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/phieukhaosat/capnhat",phieuKhaoSat);
};
function xoa(ids){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/phieukhaosat/xoa",ids);
};

const DonViService={
  them,
  getAll,
  capNhat,
  xoa,
  getByID

};
export default DonViService;
